import axios from 'axios';

async function EnviarMensaje(ape_y_nom: string, email_destino: string, telefono: string, asunto: string, mensaje: string) {
    
    const url = "https://endpoints.mapsys.com.ar/correos/enviar_correo"

    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "apeynom": ape_y_nom,
            "email": email_destino,
            "telefono": telefono,
            "asunto": asunto,
            "mensaje": mensaje
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

export default EnviarMensaje;